module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-d-flex"
  }, [_c('div', {
    staticClass: "u-position-relative",
    class: {
      'c-option-list--select-style': _vm.selectStyle
    },
    on: {
      "click": function($event) {
        return _vm.updateListOptions()
      }
    }
  }, [_c('div', {
    staticClass: "c-option-list__parent-heading u-d-inline-block",
    attrs: {
      "id": "c-option-list__parent-heading"
    }
  }, [_c('h2', {
    staticClass: "c-option-list__heading",
    class: _vm.name
  }, [_vm._v("\n                " + _vm._s(_vm.heading) + "\n            ")]), _vm._v(" "), (_vm.selectStyle) ? _c('svg', {
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#select-arrow",
      "id": "c-option-list__arrow"
    }
  })]) : _c('svg', {
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#triangle-down",
      "id": "c-option-list__arrow"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "c-option-list",
    class: _vm.name,
    attrs: {
      "id": "c-option-list"
    }
  }, [_c('ul', [_vm._t("default")], 2)])]), _vm._v(" "), (_vm.filterSelected) ? _c('div', {
    on: {
      "click": _vm.resetDefaultHeading
    }
  }, [_vm._t("add")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-02904af5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OptionList.vue
// module id = 1557
// module chunks = 0